import { atom } from "jotai";

/**
 * Describes the structure of an active command.
 * - id: A unique identifier for this specific command instance.
 * - type: The type of command (e.g., "addMedication").
 * - handled: A boolean indicating if this command has been processed by a component.
 */
export interface ActiveCommand {
  id: string;
  type: string;
  handled: boolean;
}

/**
 * Atom to track the currently active command triggered from QuickCommand.
 * Components can listen to this and react if the command is relevant to them.
 * The component that successfully handles the command should reset it to null.
 */
export const activeCommandAtom = atom<ActiveCommand | null>(null);
